import { FaFacebook } from "react-icons/fa";
import { RiInstagramFill } from "react-icons/ri";
import { BsTelegram } from "react-icons/bs";
import { IoIosArrowUp } from "react-icons/io";
import {Link} from "react-scroll";
import FlowersRpeat from "../../img/flowers_repeat.png";

import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';

function Footer() {
    return (
        <>
            <div className="fixed bottom-4 right-4  text-black bg-[#ff8048] border border-[#8f78be] p-2 rounded-[6px] z-50 cursor-pointer">
                <Link to="top" smooth={true} offset={-70} duration={500}>
                    <IoIosArrowUp />
                </Link>
            </div>
            <footer className="pt-20 pb-60 bg-center bg-no-repeat overflow-hidden bg-[#f7eae8] relative">
                <div className="container mx-auto  grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 p-4 relative z-20">
                    <div className="sm:text-xl">
                        <ScrollAnimation animateIn="animate__fadeInUp">
                            <h4 className="text-2xl mb-[16px]">Участь і партнерство</h4>
                            <p className="font-light mb-[10px]">Iрина</p>
                            <a href="tel:+380674084524"
                               className="block font-light mb-[10px] phone_partner_clk">
                                +38 (067) 408 45 24</a>
                            <a href="mailto:i.pyrog@ekonomika.ua"
                               className="block font-light mb-[10px] phone_partner_clk_1">
                                i.pyrog@ekonomika.ua</a>
                        </ScrollAnimation>
                    </div>
                    <div className="sm:text-xl">
                        <ScrollAnimation animateIn="animate__fadeInUp">
                            <h4 className="text-2xl mb-[16px]">Питання щодо участі</h4>
                            {/*<p className="font-light mb-[10px]">З питань придбання квитків*/}
                            {/*    звертатися*/}
                            {/*    в службу продажів бізнес/медіа бюро ekonomika+</p>*/}
                            <p className="font-light mb-[10px]">Яна</p>
                            <a href="tel:+380672230179"
                               className="block font-light mb-[10px] phone_sell_clk">
                                +38 (067) 223 01 79</a>
                            <a href="mailto:tickets@ekonomika.ua"
                               className="block font-light mb-[10px] email_sell_clk">
                                tickets@ekonomika.ua</a>
                            <p className="font-light mb-[10px]">Світлана</p>
                            <a href="tel:+30968369409"
                               className="block font-light mb-[10px] phone_sell_clk_1">
                                +38 096 836 94 09</a>
                        </ScrollAnimation>
                    </div>
                    <div className="sm:text-xl">
                        <ScrollAnimation animateIn="animate__fadeInUp">
                            <h4 className="text-2xl mb-[16px]">Реклама</h4>
                            <p className="font-light mb-[10px]">Ірина</p>
                            <a href="tel:+380672358382"
                               className="block font-light mb-[10px] phone_adv_clk">
                                +38 (067) 235-83-82</a>
                            <a href="mailto:i.skorohod@ekonomika.ua"
                               className="block font-light mb-[10px] phone_adv_clk_1">
                                i.skorohod@ekonomika.ua</a>
                        </ScrollAnimation>
                    </div>
                    <div>
                        <ScrollAnimation animateIn="animate__fadeInUp">
                            <h4 className="text-[18px] font-medium mb-[16px]">Слідкуйте за анонсами</h4>
                            <div className="flex gap-6 mb-9">
                                <a href="https://www.facebook.com/MMRonline" className="text-2xl"
                                   target="_blank"><FaFacebook/></a>
                                <a href="https://www.instagram.com/mmr.ua/" className="text-2xl"
                                   target="_blank"><RiInstagramFill/></a>
                                <a href="https://t.me/mmr_ua" className="text-2xl" target="_blank"><BsTelegram/></a>
                            </div>
                            <p className="mb-[16px]"><a href="/privacy-policy">Політика Приватності</a></p>
                            <p className="mb-[16px]"><a href="/offer">Оферта</a></p>
                        </ScrollAnimation>
                    </div>
                </div>
                <div className="absolute bottom-0 left-0 w-full sm:h-52 h-[200px] z-10 bg-contain" style={{ backgroundImage: `url(${FlowersRpeat})`,backgroundRepeatX: "repeat-x", backgroundRepeatY: "no-repeat" }} />
            </footer>
        </>
    )
}

export default Footer;